import React from "react";
import {
  Container,
  Box,
  Grid,
  Link,
  Typography,
  Stack,
  Item,
  Divider,
  MenuItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import MenuComponent from "../common/Menu/Menu";
import useMediaQuery from "@mui/material/useMediaQuery";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Facebook from "../../assets/images/facebook.png";
import LinkedIn from "../../assets/images/linkedin.png";
import Instagram from "../../assets/images/instagram.png";
import FacebookM from "../../assets/svgs/facebook_m.svg";
import PinterestM from "../../assets/svgs/pinterest_m.svg";
import LinkedInM from "../../assets/svgs/linkedin_m.svg";
import InstagramM from "../../assets/svgs/instagram_m.svg";
import ListComponent from "../common/ListComponent";
import { FooterPopularLinksData } from "../../tempData/data";
import { useTheme } from "@emotion/react";
import Button from "../common/Button/Button";

function Footer() {
  const theme = useTheme();
  const tabletMatches = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const mobileMatch = useMediaQuery("(max-width:600px)");
  const popularLinks = [
    "Popular buy searches",
    "Popular pro searches",
    "Popular categories",
    "Popular makes",
    "Popular models",
  ];

  const footerLinks = [
    "Buy Machinery",
    "Pro Machinery",
    "Auction Machinery",
    "Categories",
    "Advertise with us",
    "Seller Signup",
    "About us",
    "Terms of use",
    "Auction Calender",
    "Exhibition Calender",
    "Blogs",
  ];

  return (
    <Container
      disableGutters={true}
      sx={{
        paddingX: { xs: "auto", lg: "0" },
        width: "100%",
      }}
    >
      <Stack
        direction={mobileMatch ? "column" : "row"}
        sx={{
          boxShadow: {
            xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
            sm: "none",
          },
          backgroundColor: { xs: "#fff", sm: "unset" },
          columnGap: { sm: "40px" },
          justifyContent: "center",
          borderTop: { xs: "none", sm: "1px solid #D6D6D6" },
          borderBottom: { xs: "none", sm: "1px solid #D6D6D6" },
          paddingY: "24px",
          paddingX: { xs: "16px", sm: "0px" },
          borderRadius: { xs: "8px", sm: "0px" },
          // margin: { xs: "0px", sm: "0 24px" },
          flexWrap: "wrap",
          rowGap: { xs: "24px" },
        }}
        divider={
          mobileMatch ? null : (
            <Divider
              orientation="vertical"
              color="#D6D6D6"
              flexItem
              sx={{ height: "24px !important" }}
            />
          )
        }
      >
        {popularLinks.map((link) => {
          return (
            <ListComponent
              sx={{
                padding: "0px",
                width: "fit-content",
                zIndex: "0 !important",
              }}
              text={link}
              endIcon={true}
              iconColor={"#255CCE"}
            >
              {FooterPopularLinksData.map((cat) => {
                return (
                  <ListItemButton
                    disableRipple={true}
                    disableTouchRipple={true}
                    sx={{
                      padding: 0,
                      "&:hover": {
                        backgroundColor: "#fff",
                        cursor: "pointer",
                      },
                    }}
                  >
                    <ListItemText
                      primary={
                        <Typography
                          variant="body1"
                          sx={{
                            textAlign: { xs: "start", sm: "center" },
                            fontSize: "14px",
                            lineHeight: "22px",
                            "&:hover": { color: "#255CCE", cursor: "pointer" },
                          }}
                        >
                          {cat}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                );
              })}
            </ListComponent>
          );
          // <MenuComponent
          //   text={link}
          //   buttonVariant="text"
          //   buttonStyle={{ padding: "0px", height: "24px" }}
          //   icons={
          //     <KeyboardArrowDownIcon
          //       sx={{ width: "24px", height: "24px", color: "#255CCE" }}
          //     />
          //   }
          //   paperStyle={{ maxHeight: "300px", width: "160px" }}
          //   textVariant="subtitle2"
          //   textStyle={{
          //     fontSize: "14px",
          //     lineHeight: "20px",
          //     fontWeight: "600",
          //     color: "text.primary",
          //   }}
          // >
          //   {FooterPopularLinksData.map((links) => {
          //     return (
          //       <MenuItem>
          //         <Link underline="none">
          //           <Typography
          //             sx={{
          //               fontsize: "12px",
          //               lineHeight: "24px",
          //               color: "#616161",
          //             }}
          //           >
          //             {links}
          //           </Typography>
          //         </Link>
          //       </MenuItem>
          //     );
          //   })}
          // </MenuComponent>
          // );
        })}
      </Stack>

      {mobileMatch ? (
        <Container
          disableGutters={true}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow:
              "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
            width: "100%",
            height: "75px",
            marginTop: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            columnGap: "32px",
          }}
        >
          <Link sx={{ color: "text.primary", textDecoration: "none" }}>
            <img src={Facebook} alt="facebook" width="24px" height="24px" />
          </Link>
          <Link sx={{ color: "text.primary", textDecoration: "none" }}>
            <img src={Instagram} alt="instagram" width="24px" height="24px" />
          </Link>
          {/* <Link sx={{ color: "text.primary", textDecoration: "none" }}>
            <img src={PinterestM} alt="pinterest" width="24px" height="24px" />
          </Link> */}
          <Link sx={{ color: "text.primary", textDecoration: "none" }}>
            <img src={LinkedIn} alt="linkedin" width="24px" height="24px" />
          </Link>
        </Container>
      ) : (
        ""
      )}

      {tabletMatches ? (
        <Grid
          container
          xs="12"
          sx={{
            backgroundColor: "#fff",
            justifyContent: { xs: "space-evenly", lg: "center" },
            paddingY: "24px",
            paddingX: { md: "6%", lg: "10%" },
            columnGap: { xs: "32px", md: "32px" },
            alignItems: "center",
            rowGap: { xs: "16px" },
          }}
        >
          <Grid
            sx={{
              justifyContent: { xs: "center" },
              columnGap: { xs: "32px" },
              alignItems: "center",
            }}
            xs="12"
            container
          >
            <Grid
              sm="auto"
              sx={{ textAlign: { sm: "center", md: "unset" } }}
              item
            >
              <Link
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { color: "#255CCE", cursor: "pointer" },
                }}
              >
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Buy Machinery
                </Typography>
              </Link>
            </Grid>
            <Grid
              sm="auto"
              sx={{ textAlign: { sm: "center", md: "unset" } }}
              item
            >
              <Link
                href="/pro-machinery"
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { color: "#255CCE", cursor: "pointer" },
                }}
              >
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Pro Machinery
                </Typography>
              </Link>
            </Grid>
            <Grid
              sm="auto"
              sx={{ textAlign: { sm: "center", md: "unset" } }}
              item
            >
              <Link
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { color: "#255CCE", cursor: "pointer" },
                }}
              >
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Auction Machinery
                </Typography>
              </Link>
            </Grid>
            <Grid
              sm="auto"
              sx={{ textAlign: { sm: "center", md: "unset" } }}
              item
            >
              <Link
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { color: "#255CCE", cursor: "pointer" },
                }}
              >
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Categories
                </Typography>
              </Link>
            </Grid>
            <Grid
              sm="auto"
              sx={{ textAlign: { sm: "center", md: "unset" } }}
              item
            >
              <Link
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { color: "#255CCE", cursor: "pointer" },
                }}
              >
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Advertise with us
                </Typography>
              </Link>
            </Grid>
          </Grid>
          <Grid
            sx={{
              justifyContent: { xs: "center" },
              columnGap: { xs: "32px" },
              alignItems: "center",
            }}
            xs="12"
            container
          >
            <Grid
              sm="auto"
              sx={{ textAlign: { sm: "center", md: "unset" } }}
              item
            >
              <Link
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { color: "#255CCE", cursor: "pointer" },
                }}
              >
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Seller Signup
                </Typography>
              </Link>
            </Grid>
            <Grid
              sm="auto"
              sx={{ textAlign: { sm: "center", md: "unset" } }}
              item
            >
              <Link
                href="/aboutus"
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { color: "#255CCE", cursor: "pointer" },
                }}
              >
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  About us
                </Typography>
              </Link>
            </Grid>
            <Grid
              sm="auto"
              sx={{ textAlign: { sm: "center", md: "unset" } }}
              item
            >
              <Link
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { color: "#255CCE", cursor: "pointer" },
                }}
              >
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Terms of use
                </Typography>
              </Link>
            </Grid>
            <Grid
              sm="auto"
              sx={{ textAlign: { sm: "center", md: "unset" } }}
              item
            >
              <Link
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { color: "#255CCE", cursor: "pointer" },
                }}
              >
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Auction Calender
                </Typography>
              </Link>
            </Grid>
          </Grid>
          <Grid
            sx={{
              justifyContent: { xs: "center" },
              columnGap: { xs: "32px" },
              alignItems: "center",
            }}
            xs="12"
            container
          >
            <Grid sm="auto" sx={{ textAlign: { sm: "end" } }} item>
              <Link
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { color: "#255CCE", cursor: "pointer" },
                }}
              >
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Exhibition Calender
                </Typography>
              </Link>
            </Grid>
            <Grid sm="auto" sx={{ textAlign: { sm: "start" } }} item>
              <Link
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { color: "#255CCE", cursor: "pointer" },
                }}
              >
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Blogs
                </Typography>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          xs="12"
          sx={{
            boxShadow: {
              xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
              sm: "none",
            },
            marginTop: { xs: "16px", sm: "0px" },
            borderRadius: { xs: "8px", sm: "0px" },
            backgroundColor: "#fff",
            justifyContent: { xs: "start", md: "center" },
            paddingY: "24px",
            paddingX: { xs: "16px", md: "6%", lg: "10%" },
            columnGap: { xs: "32px", md: "32px" },
            alignItems: "center",
            rowGap: { xs: "16px" },
          }}
        >
          {/* {footerLinks.map((fl, index) => {
            return (
              <Grid
                xs="12"
                md="auto"
                sx={{ textAlign: { sm: "center", md: "unset" } }}
                item
              >
                <Link
                  sx={{
                    color: "text.primary",
                    textDecoration: "none",
                    "&:hover": { color: "#255CCE", cursor: "pointer" },
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "14px", lineHeight: "20px" }}
                  >
                    {fl}
                  </Typography>
                </Link>
              </Grid>
            );
          })} */}
          <Grid
            xs="12"
            md="auto"
            sx={{ textAlign: { sm: "center", md: "unset" } }}
            item
          >
            <Link
              sx={{
                color: "text.primary",
                textDecoration: "none",
                "&:hover": { color: "#255CCE", cursor: "pointer" },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                Buy Machinery
              </Typography>
            </Link>
          </Grid>

          {/*  */}
          <Grid
            xs="12"
            md="auto"
            sx={{ textAlign: { sm: "center", md: "unset" } }}
            item
          >
            <Link
              href="/pro-machinery"
              sx={{
                color: "text.primary",
                textDecoration: "none",
                "&:hover": { color: "#255CCE", cursor: "pointer" },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                Pro Machinery
              </Typography>
            </Link>
          </Grid>
          {/*  */}
          <Grid
            xs="12"
            md="auto"
            sx={{ textAlign: { sm: "center", md: "unset" } }}
            item
          >
            <Link
              sx={{
                color: "text.primary",
                textDecoration: "none",
                "&:hover": { color: "#255CCE", cursor: "pointer" },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                Auction Machinery
              </Typography>
            </Link>
          </Grid>
          {mobileMatch ? (
            <Divider sx={{ color: "#D6D6D6", width: "100%" }} />
          ) : (
            ""
          )}
          {/*  */}
          <Grid
            xs="12"
            md="auto"
            sx={{ textAlign: { sm: "center", md: "unset" } }}
            item
          >
            <Link
              sx={{
                color: "text.primary",
                textDecoration: "none",
                "&:hover": { color: "#255CCE", cursor: "pointer" },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                Categories
              </Typography>
            </Link>
          </Grid>
          {/*  */}
          <Grid
            xs="12"
            md="auto"
            sx={{ textAlign: { sm: "center", md: "unset" } }}
            item
          >
            <Link
              sx={{
                color: "text.primary",
                textDecoration: "none",
                "&:hover": { color: "#255CCE", cursor: "pointer" },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                Advertise with us
              </Typography>
            </Link>
          </Grid>
          {/*  */}
          <Grid
            xs="12"
            md="auto"
            sx={{ textAlign: { sm: "center", md: "unset" } }}
            item
          >
            <Link
              sx={{
                color: "text.primary",
                textDecoration: "none",
                "&:hover": { color: "#255CCE", cursor: "pointer" },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                Seller Signup
              </Typography>
            </Link>
          </Grid>

          {mobileMatch ? (
            <Divider sx={{ color: "#D6D6D6", width: "100%" }} />
          ) : (
            ""
          )}
          {/*  */}
          <Grid
            xs="12"
            md="auto"
            sx={{ textAlign: { sm: "center", md: "unset" } }}
            item
          >
            <Link
              sx={{
                color: "text.primary",
                textDecoration: "none",
                "&:hover": { color: "#255CCE", cursor: "pointer" },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                Auction Calender
              </Typography>
            </Link>
          </Grid>
          {/*  */}
          <Grid
            xs="12"
            md="auto"
            sx={{ textAlign: { sm: "center", md: "unset" } }}
            item
          >
            <Link
              sx={{
                color: "text.primary",
                textDecoration: "none",
                "&:hover": { color: "#255CCE", cursor: "pointer" },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                Exhibition Calender
              </Typography>
            </Link>
          </Grid>

          {mobileMatch ? (
            <Divider sx={{ color: "#D6D6D6", width: "100%" }} />
          ) : (
            ""
          )}
          <Grid
            xs="12"
            md="auto"
            sx={{ textAlign: { sm: "center", md: "unset" } }}
            item
          >
            <Link
              sx={{
                color: "text.primary",
                textDecoration: "none",
                "&:hover": { color: "#255CCE", cursor: "pointer" },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                Blogs
              </Typography>
            </Link>
          </Grid>
          <Grid
            xs="12"
            md="auto"
            sx={{ textAlign: { sm: "center", md: "unset" } }}
            item
          >
            <Link
              href="/aboutus"
              sx={{
                color: "text.primary",
                textDecoration: "none",
                "&:hover": { color: "#255CCE", cursor: "pointer" },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                About us
              </Typography>
            </Link>
          </Grid>
          <Grid
            xs="12"
            md="auto"
            sx={{ textAlign: { sm: "center", md: "unset" } }}
            item
          >
            <Link
              sx={{
                color: "text.primary",
                textDecoration: "none",
                "&:hover": { color: "#255CCE", cursor: "pointer" },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                Terms of use
              </Typography>
            </Link>
          </Grid>
          {mobileMatch && (
            <Grid
              xs="12"
              md="auto"
              sx={{ textAlign: { sm: "center", md: "unset" } }}
              item
            >
              <Divider sx={{ color: "#D6D6D6", width: "100%" }} />
              <Button
                bgColor={"#3A474E"}
                size="small"
                typoVariant={"subtitle2"}
                typoSize="14px"
                fontWeight="500"
                txColor={"#fff"}
                sx={{ height: "40px", width: "100%", marginTop: "24px" }}
              >
                Sell with us
              </Button>
            </Grid>
          )}
        </Grid>
      )}

      {/* </Grid> */}

      <Divider
        sx={{
          color: "#D6D6D6",
          width: { xs: "100%", md: "600px" },
          marginX: "auto",
        }}
      />

      <Container sx={{ textAlign: "center", paddingY: { xs: "16px" } }}>
        <Typography sx={{ fontSize: "12px", color: "#616161" }}>
          Jumeirah Lake Towers. Cluster R, Unit R6. Dubai, UAE
        </Typography>
        <Link href="" underline="none">
          <Typography
            sx={{
              fontSize: "12px",
              color: "text.primary",
              marginTop: "8px",
              marginBottom: { xs: "16px", sm: "0px" },
              "&:hover": {
                color: "#255CCE",
              },
            }}
          >
            info@machineryplanet.ae
          </Typography>
        </Link>
        {mobileMatch ? (
          ""
        ) : (
          <Container
            sx={{
              marginTop: "20px",
              marginBottom: "24px",
              display: "flex",
              columnGap: "24px",
              justifyContent: "center",
            }}
          >
            <Link sx={{ color: "text.primary", textDecoration: "none" }}>
              <img src={Facebook} alt="facebook" width="24px" height="24px" />
            </Link>
            <Link sx={{ color: "text.primary", textDecoration: "none" }}>
              <img src={Instagram} alt="instagram" width="24px" height="24px" />
            </Link>
            {/* <Link sx={{ color: "text.primary", textDecoration: "none" }}>
            <img src={PinterestM} alt="pinterest" width="24px" height="24px" />
          </Link> */}
            <Link sx={{ color: "text.primary", textDecoration: "none" }}>
              <img src={LinkedIn} alt="linkedin" width="24px" height="24px" />
            </Link>
          </Container>
        )}
        <Typography sx={{ fontSize: "12px", color: "#616161" }}>
          © 2020-{new Date().getFullYear()} Machinery Planet. All rights
          reserved.
        </Typography>
      </Container>
    </Container>
  );
}

export default Footer;
